/// <amd-module name="TFS/CreateProject/Components/ProjectLimitPanel" />
import * as React from "react";
import { IStatus } from "TFS/CreateProject/Models";
import { IVssComponentContext, VssComponent } from "VSS/Platform/Layout";
import { MessageBar, MessageBarSeverity } from "VSSUI/MessageBar";
import { StatusValueType } from "../Contracts";

export interface IProjectLimitPanelProps {
    status: IStatus;
}

export class ProjectLimitPanel extends VssComponent<IProjectLimitPanelProps, {}> {
    constructor(props: IProjectLimitPanelProps, context: IVssComponentContext) {
        super(props, context);
    }

    public render(): JSX.Element | null {
        const { status } = this.props;

        const statusMessageType: StatusValueType = status.value;
        const statusMessageContent = status.message;
        let messageBarType;

        if (statusMessageType == StatusValueType.Failure) {
            // if failure, show error as it is above limit
            messageBarType = MessageBarSeverity.Error;
        } else {
            // if success or any other status, only show warning as it is below limit
            messageBarType = MessageBarSeverity.Warning; // Warning: 1, NoStatus: 0
        }

        if (messageBarType === MessageBarSeverity.Warning && (!statusMessageContent || statusMessageContent.trim().length === 0)) {
            return null;
        }

        return (
            <div className="project-limit-warning-container margin-16">
                <MessageBar severity={messageBarType}>{statusMessageContent}</MessageBar>
            </div>
        );
    }
}
